import EmptyState from '../components/EmptyState';

export default function N1() {
  return (
    <EmptyState
      title="N+1"
      description="N+1 comprehensible input sequencing and difficulty curves"
    />
  );
}
